import React, { forwardRef } from "react";
import styles from "./HighlightsSlider.module.scss";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import { getCarDBAssetSrcSet } from "../../../../../../shared-logic/utils/imageUtils";
import TruncatedText from "../TruncatedText";
import type { GradeFeaturesType } from "../../../../redux/slices/CarConfigGradesSlice";
import { useCarConfigSelector } from "../../../../redux/store";
import { useAphBreakpoint } from "../../../../../shared-logic/hooks/useBreakpoint";

const HighlightsSliderItem = forwardRef<HTMLDivElement, { feature: GradeFeaturesType; index: number }>((props, ref) => {
    const { feature } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const isMobile = useAphBreakpoint("down", "xl");

    return (
        <article ref={ref} className={styles.slide}>
            <Text tag="h3" variant="apheleia-h4">
                {feature.subtitle || feature.name}
            </Text>

            {feature.assets?.[1] && (
                <figure>
                    <img
                        {...getCarDBAssetSrcSet(
                            commonSettings,
                            [180, 225, 336, 386, 426, 772, 852].map((size) => ({
                                width: size,
                                height: size,
                            })),
                            feature.assets[1].url,
                        )}
                        alt=""
                        role="presentation"
                        loading="lazy"
                        draggable={false}
                    />
                </figure>
            )}

            <TruncatedText text={feature.description} maxLength={isMobile ? 150 : 300} />
        </article>
    );
});

export default HighlightsSliderItem;
